const HIPAABAAPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Business Associate Agreement (BAA)</h1>
        <p className="text-gray-600 mb-8">Last updated: November 2025</p>

        <div className="prose prose-lg max-w-none space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Overview</h2>
            <p>
              This Business Associate Agreement (BAA) is entered into by and between Acuity Practice ("Business Associate") and the covered entity or client using our services ("Covered Entity"), in accordance with the Health Insurance Portability and Accountability Act (HIPAA) and the Health Information Technology for Economic and Clinical Health (HITECH) Act.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Definitions</h2>
            <p><strong>Protected Health Information (PHI):</strong> Information in a medical record or health plan that can be used to identify an individual.</p>
            <p><strong>Business Associate:</strong> A person or entity that on behalf of a covered entity processes or obtains access to PHI.</p>
            <p><strong>Covered Entity:</strong> Healthcare providers that transmit any health information in electronic form.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Use and Disclosure of PHI</h2>
            <p>
              The Business Associate agrees to use, receive, maintain, and transmit PHI only for the purposes specified in the service agreement and as permitted or required by law. The Business Associate shall not use or further disclose PHI except as required by law or as authorized by the Covered Entity in writing.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Safeguards for PHI</h2>
            <p>The Business Associate shall implement and maintain the following safeguards:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Administrative safeguards including policies and procedures for access control</li>
              <li>Physical safeguards including encryption and secure facility access</li>
              <li>Technical safeguards including user authentication and audit controls</li>
              <li>Encryption of PHI both in transit and at rest</li>
              <li>Regular security assessments and risk analyses</li>
              <li>Business continuity and disaster recovery plans</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Breach Notification</h2>
            <p>
              In the event of a breach of PHI, the Business Associate shall notify the Covered Entity without unreasonable delay and in no case later than 60 calendar days after discovery of the breach. The notification shall include the date of discovery, description of the breach, and measures being taken to mitigate harm.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Subcontractors</h2>
            <p>
              The Business Associate shall ensure that any subcontractors who have access to PHI enter into a Business Associate Agreement that includes the same protections and restrictions on the use of PHI.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Audit Controls</h2>
            <p>
              The Business Associate shall implement systems to record and examine access to and use of PHI. Audit controls shall be implemented to create an audit trail of access to PHI.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Termination and Return of PHI</h2>
            <p>
              Upon termination of the service agreement, the Business Associate shall either return or destroy all PHI in its possession, at the election of the Covered Entity. The Business Associate shall certify that all PHI has been returned or destroyed.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Compliance and Monitoring</h2>
            <p>
              The Business Associate shall permit access to and inspection of its facilities, books, records, and systems by the Covered Entity and the Department of Health and Human Services for purposes of monitoring and enforcement of HIPAA compliance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Contact Information</h2>
            <p>
              For questions regarding this Business Associate Agreement or HIPAA compliance, please contact:
            </p>
            <p>
              <strong>Acuity Practice HIPAA Compliance Officer</strong><br />
              Trust Tech Digital<br />
              <a href="mailto:hipaa@acuitypractice.com" className="text-primary-500 hover:text-primary-600">hipaa@acuitypractice.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default HIPAABAAPage
